import './index.css'
import './i18n'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import configurationSetting from './api/httpClient'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'

configurationSetting(store)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <App
      remoteDependencies={{
        store,
        parent: 'remote',
      }}
    />
  </Provider>,
  document.getElementById('root')
)

reportWebVitals()
